interface ReassuranceItem {
  icon: string;
  text: string;
}

interface ReassuranceBarProps {
  items: ReassuranceItem[];
}

export default function ReassuranceBar({ items }: ReassuranceBarProps) {
  return (
    <div className="w-full bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-5">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div key={item.text} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-mango-500 text-2xl`}></i>
              </div>
              <span className="text-white text-sm md:text-base font-medium leading-tight">
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}